<template>
  <a v-if="infoLink" :href="infoLink" class="page-info-link" target="_blank">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
      <path
        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z"
      />
    </svg>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'infoBtn',
    computed: {
        ...mapGetters({
            infoLink: 'infoLink',
        }),
    },
}
</script>

<style lang="scss" scoped>
.page-info-link {
  position: fixed;
  bottom: 88px;
  right: 29px;

  svg {
    fill: #f6bb0b;
  }
}
</style>
